// extracted by mini-css-extract-plugin
export default {"root":"UserLogged_root__GNaLi","position":"UserLogged_position__cl8mR"};